<template>
    <v-app
        v-if="user"
        class="gst-layout-default">
        <navigation-drawer />
        <v-main class="gst-content-container">
            <div class="gst-header-container">
                <Header class="gst-header" />
            </div>
            <v-container
                class="container container-layout"
                fluid>
                <Breadcrumbs
                    v-if="routeHasBreadcrumbs"
                    :i18n-keys="routeBreadcrumbs"
                    class="mb-4" />
                <div
                    v-if="loading"
                    class="justify-center d-flex loader-wrapper u-height-100 align-center">
                    <DataLoading
                        class="mt-n6"
                        size="30" />
                </div>
                <slot v-else></slot>
                <Footer class="mt-6 pa-4" />
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { DataLoading } from '@components/loading';
import Breadcrumbs from '@components/Breadcrumbs.vue';
import { Header, Footer, NavigationDrawer } from './Default/index';

export default {
    name: 'Default',
    components: {
        Breadcrumbs,
        DataLoading,
        Header,
        Footer,
        NavigationDrawer,
    },
    computed: {
        ...mapGetters({
            user: 'oidcStore/oidcUser',
            userLoaded: 'user/isLoaded',
            userRoles: 'user/roles',
            userPartnersAllLoaded: 'user/partners/allItemsLoaded',
        }),
        loading() {
            return !(this.userLoaded && this.userRoles.length > 0) || !this.userPartnersAllLoaded;
        },
        routeBreadcrumbs() {
            return this.$route.meta.breadcrumb;
        },
        routeHasBreadcrumbs() {
            return this.routeBreadcrumbs && this.routeBreadcrumbs.length;
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';

.gst-layout-default .gst-header.v-sheet.v-app-bar.v-toolbar {
    background-color: theme-color('primary');
    color: theme-color('white');
    width: 100%;
    height: 100%;
}

.gst-layout-default .container-layout {
    height: calc(100% - 91px);
    padding: theme-spacing(6) theme-spacing(4);
}

.gst-header-container {
    position: sticky;
    top: 0;
    z-index: 10;
}

@media print {
    .gst-content-container,
    .gst-header-container {
        padding-left: theme-spacing(0) !important;
    }
}
</style>
